module.exports = __webpack_public_path__ + "img/intro4.db63fd57.svg";